import BannerTop from './BannerTop';

export default BannerTop;
